import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InlineListItem from "./InlineListItem";
import './InlineList.css';

/**
 * Grid Blocks Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 * @author Emily Anderson <eanderson@wearearchitect.com>
 */
export default class InlineList extends Component {

    /**
     * Default props
     *
     * @type {{className: string}}
     */
    static defaultProps = {
        inlineListClassNames: classNames('InlineList'),
    };

    /**
     * Prop Types
     *
     * @type {{className, data: *}}
     */
    static propTypes = {
        inlineListClassNames: PropTypes.string,
        inlineListItem: PropTypes.string,
        className: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.object).isRequired
    };

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {

        const {data, inlineListClassNames} = this.props;

        let inlineListItems = data.map(function (inlineListItem, index) {

            const {header, image, imageAlt, link, text} = inlineListItem;

            return <InlineListItem header={header}
                                   image={image}
                                   imageAlt={imageAlt}
                                   link={link}
                                   key={index}
                                   text={text}/>
        });

        return (
            <ul className={inlineListClassNames}>
                <React.Fragment>
                    {inlineListItems}
                </React.Fragment>
            </ul>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/global/inlineList/InlineList.jsx